<template>
  <div class="w-full">
    <h2 class="w-full mb-4 text-center">
      <span :class="{ 'font-montserrat': isContributor }">Delete Post</span>
    </h2>

    <p class="mb-4 text-md text-center">
      Do you want to delete this post forever?
    </p>

    <button
      :disabled="submitting"
      type="submit"
      :class="[
        isContributor ? 'btn-cw-cd-primary' : 'btn-primary',
        { 'cursor-not-allowed': submitting },
      ]"
      class="btn m-auto mt-10 relative"
      @click="submit"
    >
      <div
        class="absolute inset-0 w-full flex justify-center items-center z-20"
      >
        <lottie v-if="submitting" :options="loadingAnimationOptions" />
      </div>
      <span :class="[submitting ? 'invisible' : '']">Confirm</span>
    </button>
  </div>
</template>

<script>
import { EventBus } from '../../js/plugins/event-bus.js'
import { defineComponent, ref } from 'vue'
import { useStore } from '../../js/store/index.js'
import * as loadingAnimation from './loading.json'

/**
 * Currently this component is only implemented for contributors (`isContributor`).
 * @todo contain all delete logic in this one component:
 * cw/central/tenancy/expo/etc management should be passed via config prop
 * or handled globally in the store; current delete logic is all over the place,
 * for some reason using `parent` and `parent_id` rather than just the post id
 * and I cannot deal with it. This component should lay the foundation going forwards.
 */

export default defineComponent({
  name: 'ModalPostDelete',

  props: {
    config: {
      type: Object,
      default: () => null,
    },
  },

  setup(props) {
    const store = useStore()
    const isContributor = store.getters['shared/isContributor']

    const postId = props.config?.postId || null
    const submitting = ref(false)

    const contributorsPostDelete = async () => {
      await store.dispatch('contributors/dispatchDeletePost', postId)
    }

    const submit = async () => {
      if (submitting.value) {
        return
      }

      submitting.value = true
      await contributorsPostDelete()
      submitting.value = false
      EventBus.$emit('showModal', false)
      EventBus.$emit('closeOtherPostsManagerMenus')
    }

    return {
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      isContributor,
      submitting,
      submit,
    }
  },
})
</script>
